import { colors } from 'theme/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';
import gundi_logo from 'images/gundi_logo.png';
import wildlifePhoto from 'images/login-wildlife.jpg';

type Props = {
  title: string;
  subtitle: string;
  onLogin: () => void;
  titleId?: string;
};

export function LoginScreen({ title, subtitle, onLogin, titleId }: Props) {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-full">
      <div
        className="relative hidden w-1/2 flex-shrink-0 overflow-hidden lg:flex"
        style={{ background: colors['unlisted-login-overlay-strong'] }}
      >
        <img
          src={wildlifePhoto}
          alt=""
          className="h-full w-full object-cover"
          style={{ transform: 'scale(1.6) translateY(5%)' }}
        />
        <div
          className="absolute inset-0"
          style={{ background: colors['unlisted-login-overlay-soft'] }}
        />
        <div className="absolute left-4 top-4 flex items-center gap-3">
          <img
            src={gundi_logo}
            alt=""
            className="flex-shrink-0 brightness-0 invert"
            style={{ width: '38px', height: '32px' }}
          />
          <span
            className="font-bold text-white"
            style={{ width: '63px', fontSize: '1.25rem', lineHeight: 1 }}
          >
            Gundi
          </span>
        </div>
        <div className="absolute bottom-8 left-8">
          <span
            style={{
              color: colors['ui-background-elevated-component'],
              fontFeatureSettings: "'liga' off",
              textShadow: `0 4px 4px ${colors['unlisted-scrim-25']}`,
              fontFamily: '"Helvetica Neue"',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: 'normal',
            }}
          >
            Photo credit: Jes Lefcourt
          </span>
        </div>
      </div>
      <div
        className="flex flex-1 flex-col items-center justify-center px-12 py-6"
        style={{ background: colors['unlisted-login-panel-grey'] }}
      >
        <div className="mb-10 flex flex-col items-center justify-center">
          <img src={gundi_logo} alt="Gundi" className="mb-3 h-10" />
          <span className="text-[32px] font-bold tracking-tight text-ui-text-primary-text">
            Gundi
          </span>
        </div>
        <p
          id={titleId}
          className="mb-2 text-center text-lg font-semibold text-ui-text-primary-text"
        >
          {title}
        </p>
        <p className="mb-8 text-center text-base text-ui-text-primary-text">
          {subtitle}
        </p>
        <button
          type="button"
          className="m-0 box-border flex h-12 w-full max-w-[350px] items-center justify-center rounded-md border border-transparent bg-brand-accent-green p-4 text-base font-bold text-white shadow-sm transition-colors hover:bg-ui-cta-primary focus:outline-none focus:ring-2 focus:ring-ui-cta-primary focus:ring-offset-2"
          onClick={onLogin}
        >
          {t('Log In')}
        </button>
        <p className="mt-4 text-center text-sm font-medium text-unlisted-form-help-grey">
          {t('No account?')}{' '}
          <a
            href="https://support.earthranger.com/gundi-getting-help/gundi-contact-us"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-ui-cta-primary hover:text-ui-cta-primary"
          >
            {t('Contact us')}
          </a>
        </p>
      </div>
    </div>
  );
}
